import { render, staticRenderFns } from "./ReferralCampaignBanner.vue?vue&type=template&id=5cd00c82&scoped=true"
import script from "./ReferralCampaignBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReferralCampaignBanner.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ReferralCampaignBanner.vue?vue&type=style&index=0&id=5cd00c82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd00c82",
  null
  
)

export default component.exports